
import TimeUtils from '@front/volcanion/utils/time'
import BillingUtils from '@front/volcanion/utils/billing'
import FormatUtils from '@front/squirtle/utils/format'

import moment from 'moment'
class Callbacks {
  static refreshETAHandler(getDetails, setEta, setEstimatedDelay) {
    return async function refreshETA(driver_opts, vehicle_opts, source_details, owner, commercial_package, load_count, has_luggage) {
      const { eta } = await getDetails({
        owner,
        filter: {
          ..._.pick(source_details, ['place_id', 'address_id', 'poi_client_id', 'coordinates', 'poi_id'])
        },
        options: {
          request: ['eta'],
          commercial_package,
          driver_opts,
          vehicle_opts,
          load_count,
          has_luggage
        }
      })

      setEstimatedDelay(TimeUtils.secondsToTime(moment(eta).diff(moment(), 'seconds'), 'HH[h]mm[min]'))
      setEta(eta)
    }
  }
  static getCustomPropsHandler(selectedEstimation, selectedDriverEstimation, order, requestedAtFieldValue, schedule_type, eta, margin) {
    return function getCustomProps() {
      if (!!selectedEstimation) {
        return {
          price: BillingUtils.getEstimationDisplay(selectedEstimation?.details?.pricing, true, 2),
          driver_price: BillingUtils.getEstimationDisplay(selectedDriverEstimation?.details?.pricing, true, 2),
          distance: FormatUtils.distance(_.get(selectedEstimation, 'details.distances.total', 0)),
          pickup: schedule_type === 'planned'
            ? moment(requestedAtFieldValue).add(margin || 0, 'minutes')
            : eta,
          duration: TimeUtils.secondsToTime(_.get(selectedEstimation, 'details.durations.total', 0), null, { hide_seconds: true }),
          empty_fee: selectedEstimation?.details?.pricing?.elements?.empty_fee,
          voucher_amount: selectedEstimation?.details?.pricing?.subtotal?.voucher_amount
        }
      } else if (!!order) {
        const { info: { dest_datetime, src_datetime }, requestedAt, quotation, driver_estimation } = order
        const live_eta = order?.current_target?.eta?.time
        const estimatedDelay = TimeUtils.secondsToTime(!!live_eta
          ? moment(live_eta).diff(moment(), 'seconds')
          : moment(src_datetime).diff(moment(requestedAt), 'seconds'), null, { hide_seconds: true })
        return {
          estimatedDelay,
          price: BillingUtils.getEstimationDisplay(quotation, false, 2),
          driver_price: BillingUtils.getEstimationDisplay(driver_estimation, false, 2),
          distance: FormatUtils.distance(_.get(quotation, 'distance') || 0),
          duration: !!dest_datetime && TimeUtils.secondsToTime(moment(dest_datetime).diff(moment(src_datetime), 'seconds'), null, { hide_seconds: true }),
          pickup: src_datetime,
          empty_fee: order?.quotation?.empty_fee,
          voucher_amount: order?.quotation?.voucher_amount,
          isLiveETA: !!live_eta
        }
      } else return {}
    }
  }
}

export default Callbacks
